import './style/main.css'
import Application from './javascript/Application.js'

//console.log(import.meta.env)

window.application = new Application({
    $canvas: document.querySelector('.js-canvas'),
    useComposer: true
})
